// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__109nv","right":"styles_right__3c3K9"};